import React from 'react';

export default function StepPeople({ onNext }) {
  return (
    <div style={{padding:24}}>
      <h3>People</h3>
      <p>Owner will be added automatically.</p>
      <div style={{marginTop:12}}>
        <button onClick={onNext}>Next</button>
      </div>
    </div>
  );
}
